<template>
    <footer class="o-d-footer d-footer">
        <OServicesPreview />
        <MVersions />
    </footer>
</template>

<script>
import OServicesPreview from '../../organisms/o-services-buttons/o-services-buttons';
import MVersions from '../../molecules/m-versions/m-versions';

export default {
    name: 'ODFooter',
    components: {
        OServicesPreview,
        MVersions
    }
}
</script>

<style lang="scss">
@import "o-d-footer.scss";    
</style>